
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiOwnShipRemoteZ as ObiOwnShipRemoteZElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-own-ship-remote-z.js';
 
 
 

 
 export const ObiOwnShipRemoteZ = createComponent({
   react: React,
   tagName: 'obi-own-ship-remote-z',
   elementClass: ObiOwnShipRemoteZElement,
   events: {
     
   }
  });
 
 